import { useEffect, useState } from "react";
import { useAuthContext } from "../../../context/AuthContext";
import { checkConnection } from "../../../printerConnection";
import { PrinterSteps } from "./printerSteps";
import PrinterListing from "./printerListing";
import { Box, CircularProgress } from "@mui/material";
import styles from "./styles.module.css";
import { useSnackbar } from "../../../context/SnackbarContext";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const PrinterContainer = ({ viewMode, setViewMode }) => {
  const { business } = useAuthContext();
  const { showSnackbar } = useSnackbar();
  const [listOfPrinters, setListOfPrinters] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchPrinters = async () => {
    try {
      const res = await checkConnection(business);
      const printers = res?.[1] || [];
      setListOfPrinters(printers);
      if (printers && printers?.length) {
        setViewMode("printers");
        triggerLogEvent(analytics, "printer_list_view");
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const loadPrinterList = async () => {
    try {
      setLoading(true);
      const res = await checkConnection(business);
      const printers = res?.[1] || [];
      setListOfPrinters(printers);
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrinters();
  }, []);

  useEffect(() => {
    if (activeStep === 1) {
      loadPrinterList();
      triggerLogEvent(analytics, "printer_setup_start");
    }
  }, [activeStep]);

  if (loading) {
    return (
      <Box className={styles.loadingContainer}>
        <CircularProgress size="30px" />
      </Box>
    );
  }

  if (viewMode === "printers") {
    return <PrinterListing listOfPrinters={listOfPrinters} />;
  }

  return (
    <PrinterSteps
      listOfPrinters={listOfPrinters}
      setListOfPrinters={setListOfPrinters}
      setViewMode={setViewMode}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      setLoading={setLoading}
    />
  );
};

export default PrinterContainer;
